// extracted by mini-css-extract-plugin
module.exports = {"image":"style_image_3epkA","field":"style_field_10tm2"};